import React from 'react';
import Reveal from '../../../shared/Reveal/Reveal';
import eagle from '../../../../assets/images/wealthandsavingsdetails/savings/eagle.svg';
import './Savings.css';

const Savings = ({ quote, eagleImage }) => {
  if (!quote) {
    return null;
  }

  return (
    <section className="wealth-savings-quote">
      <div className="wealth-savings-quote__inner">
        <Reveal as="blockquote" className="wealth-savings-quote__text">
          {quote}
        </Reveal>

        <Reveal className="wealth-savings-quote__eagle-wrap" delay={120}>
          <img
            className="wealth-savings-quote__eagle"
            src={eagleImage || eagle}
            alt=""
            aria-hidden="true"
          />
        </Reveal>
      </div>
    </section>
  );
};

export default Savings;
